import { _executeModel } from 'lib/react-geo-tool/packages/react-api/src/';
import { Methods, executeTask } from '@carto/react-workers';
import { normalizeObjectKeys, wrapModelCall } from './utils';

export function getCategories(props) {
  return wrapModelCall(props, fromLocal, fromRemote);
}

// From local
function fromLocal(props) {
  const { source, column, operationColumn, operation, joinOperation } = props;

  return executeTask(source.id, Methods.FEATURES_CATEGORY, {
    filters: source.filters,
    filtersLogicalOperator: source.filtersLogicalOperator,
    operation,
    joinOperation,
    column,
    operationColumn: operationColumn || column
  });
}

// From remote
function fromRemote(props) {
  const { source, spatialFilter, abortController,spatialTable, ...params } = props;
  const { column, operation, operationColumn,parametersCatalog } = params;

  return _executeModel({
    model: 'category',
    source,
    spatialFilter,
    spatialTable,
    params: {
      column,
      operation,
      operationColumn: operationColumn || column,
      parametersCatalog
    },
    opts: { abortController }
  }).then((res) => normalizeObjectKeys(res.rows));
}
